<template>
    <v-card class="card-container">
        <v-card-title class="py-0">
            <v-row>
                <v-col cols="auto">
                    <v-btn
                            dense
                            color="var(--color-blue)"
                            @click="showAddModal"
                            dark
                    >
                        <span class="btn-text"><v-icon dark>add</v-icon> Добавить сотрудника</span>
                    </v-btn>
                </v-col>
                <v-col >
                    <v-text-field
                            class="search-block"
                            v-model="search"
                            prepend-inner-icon="mdi-magnify"
                            single-line
                            solo
                            placeholder="Поиск сотрудника"
                            dense
                            hide-details
                    />
                </v-col>
                <v-col cols="auto">
                    <span class="subheader-label">Фильтр:</span>
                </v-col>
                <v-col cols="2">
                    <v-select
                            v-model="selectedAccessLevels"
                            multiple
                            item-text="name"
                            item-value="id"
                            solo
                            dense
                            hide-details
                            :items="accessLevelItems"
                    >
                        <template v-slot:prepend-item>
                            <v-list-item
                                    ripple
                                    @click="toogleAllLevels"
                            >
                                <v-list-item-action>
                                    <v-icon :color="selectedAccessLevels.length > 0 ? 'indigo darken-4' : ''">
                                        {{ icon }}
                                    </v-icon>
                                </v-list-item-action>
                                <v-list-item-content>
                                    <v-list-item-title>
                                        Выбрать все
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-divider class="mt-2"></v-divider>
                        </template>
                        <template v-slot:selection="{ item, index }">
                            <div v-if="likesAllLevels">
                                <span v-if="index === 0">Все</span>
                            </div>
                            <div v-else>
                                <span v-if="index === 0">{{ item.name }}</span>
                                <span
                                        v-if="index === 1"
                                        class="grey--text caption"
                                >
                                        (+{{ selectedAccessLevels.length - 1 }})
                                    </span>
                            </div>

                        </template>
                    </v-select>
                </v-col>
                <v-spacer></v-spacer>
            </v-row>
        </v-card-title>
        <v-card-text class="h-100 p-0" style="overflow-y: scroll">
            <v-container fluid class="h-100">
                <v-data-table
                        :loading="loading"
                        :search="search"
                        no-data-text="Нет элементов"
                        no-results-text="Не найдено элементов"
                        loading-text="Загрузка данных"
                        calculate-widths
                        :items-per-page="filteredItems.length"
                        :items="filteredItems"
                        :headers="fields"
                        height="100%"
                        hide-default-footer
                        class="elevation-1 h-100"
                >
                    <template v-slot:item.orgGeoName="{item}">
                        <span>{{item.orgGeoInfo==null?"Все филиалы":item.orgGeoInfo}}</span>
                    </template>
                    <template v-slot:item.webUserLogo="data">
                        <v-avatar
                                size="45px"
                                color="accent"
                        >
                            <img
                                    v-if="data.item.webUserLogo!=null"
                                    :src="$root.docsUrl+data.item.webUserLogo"
                            >
                            <span v-else>{{ data.item.account.substr(0,2) }}</span>
                        </v-avatar>
                    </template>
                    <template v-slot:item.edit="{item}">
                        <v-btn icon @click="showEditModal(item)">
                            <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                    </template>
                </v-data-table>

            </v-container>

        </v-card-text>

        <addModal :show="showAdd" :organizationItem="item" @close="closeAdd"></addModal>
        <editModal :show="showEdit" :organization="item" :item="selectedStaff" @close="closeEdit"></editModal>
    </v-card>
</template>

<script>
    import addModal from '../dictionaries/PartnerStaff/AddNewStaffModal.vue'
    import editModal from '../dictionaries/PartnerStaff/EditStaffModal.vue'

    export default {
        name: "PartnerInfoStaff",
        props:["item"],
        components:{addModal, editModal},
        data(){
            return {
                loading:false,
                selectedStaff:null,
                selectedAccessLevels:[],
                search:null,
                showAdd:false,
                showEdit:false,
                fields:[
                    {text: '', value: 'webUserLogo'},
                    {
                        text: 'ФИО сотрудника',
                        value: 'userName',
                        sortable: true
                    },
                    {text: 'Роль', value: 'accessLevelName'},
                    {text: 'Филиал', value: 'orgGeoName'},
                    {text: 'Последняя активация', value: 'lastActivation'},
                    {text: '', value: 'edit'}
                ]

            }
        },
        mounted(){
           this.getStaffItems();

            this.$store.dispatch("Partners/getUserAccessLevels").catch(error=>{
                this.$bvToast.toast(error.response.data != null ? error.response.data : error, {
                    title: `Ошибка получения уровней доступа!`,
                    variant: "danger",
                    toaster: 'b-toaster-bottom-right',
                    autoHideDelay: 3000,
                    solid: true
                })
            })
        },
        computed:{


            filteredItems(){
                var items = this.$store.state.Partners.partnerStaff;
                if (items != null) {
                    return items
                }
                else return [];
            },

            accessLevelItems(){
                return this.$store.state.Partners.accessLevels
            },

            icon () {
                if (this.likesAllLevels) return 'mdi-close-box'
                if (this.likesSomeLevels) return 'mdi-minus-box'
                return 'mdi-checkbox-blank-outline'
            },

            likesSomeLevels () {
                return this.selectedAccessLevels.length > 0 && !this.likesAllLevels
            },

            likesAllLevels() {
                return this.selectedAccessLevels.length === this.accessLevelItems.length
            },
        },
        methods:{
            getStaffItems(){
                const vm=this;
                this.loading=true
                this.$store.dispatch("Partners/getPartnerStaff", this.item.id).then(x=>vm.loading=false).catch((err) => {
                    console.log(err)
                    this.loading=false;
                    this.$bvToast.toast(err.message, {
                        title: `Ошибка загрузки списка сотрудников!`,
                        variant: "danger",
                        toaster: 'b-toaster-bottom-right',
                        autoHideDelay: 3000,
                        solid: true
                    })
                });
            },

            showAddModal(){
                this.showAdd=true
            },

            showEditModal(item){
                this.selectedStaff=item
                this.showEdit=true
            },

            closeAdd(isSave){
                this.showAdd=false
                if(isSave==true){
                    this.getStaffItems()
                }
            },
            closeEdit(isSave){
                this.showEdit=false
                if(isSave==true){
                    this.getStaffItems()
                }
            },

            toogleAllLevels(){
                this.$nextTick(() => {
                    if (this.likesAllLevels) {
                        this.selectedAccessLevels = []
                    }
                    else {
                        this.selectedAccessLevels = []
                        this.accessLevelItems.forEach(item => {
                            this.selectedAccessLevels.push(item.id)
                        })
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>